import React from 'react';
import footer from './assets/footer.png';
import logo from './assets/logolight.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Bounce, Fade, Slide } from 'react-reveal';

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLinkClick = (to) => {
    if (location.pathname !== to) {
      // Scroll to the top of the page
      window.scrollTo(0, 0);
      // Navigate to the new location
      navigate(to);
    }
  };

  return (
    <div className='bg-black text-white p-5 pt-8'>
      <div className='flex flex-col pb-5 md:flex-row md:px-[3%] md:justify-between items-start'>
        <div className='text-left md:max-w-[53%] lg:max-w-[40%]'>
          <Bounce>
            <img className='max-w-[30%] lg:max-w-[25%]' src={logo} alt="light themed logo" />
          </Bounce>
          <Fade left>
            <h6 className='py-2 lg:text-lg'>We are a community driven organization empowering and educating individuals through the Web3 journey. As believers, we pave the way for innovative solutions, community driven initiatives and a collective vision of progress steps into the world of Web3.</h6>
          </Fade>
        </div>
        <div className='flex lg:justify-between flex-wrap lg:flex-nowrap pt-3 lg:pt-0 lg:w-[100%] md:pl-[6%]  lg:pl-[22%]'>
          <Slide bottom>
            <div className="w-1/2">
            <h5 className='text-primary font-semibold'>Links</h5>
            <nav className="list-none footer-links">
              <li><Link to="/about" onClick={() => handleLinkClick('/about')}>About Us</Link></li>
              <li><a href="https://medium.com/@walkersdao" target='_blank' rel="noreferrer">Our Blog</a></li>
              <li><Link to="/faq" onClick={() => handleLinkClick('/faq')}>FAQs</Link></li>
              <li><Link to="/what_we_do" onClick={() => handleLinkClick('/what_we_do')}>What we do</Link></li>
              <li><a href="https://linktr.ee/walkersdao" target='_blank' rel="noreferrer">Linktree</a></li>
            </nav>
            </div>
          </Slide>
          <Slide bottom>
            <div className="w-1/2">
            <h5 className='text-primary font-semibold'>Address</h5>
            <nav className="list-none max-w-[90%]">
              <li>Remote</li>
            </nav>
            <h5 className='text-primary pt-5 font-semibold'>Careers</h5>
            <nav className="list-none max-w-[90%]">
              <li>Coming Soon</li>
            </nav>
          </div>
          </Slide>
          <Slide bottom>
            <div className="w-1/2 pt-5 lg:pt-0">
            <h5 className='text-primary font-semibold'>Contact Us</h5>
            <nav className="list-none">
              <li><a href="tel:+2349027511282">+234 902 751 1282</a></li>
              <li><a href="mailto:walkersdao1@gmail.com">walkersdao1@gmail.com</a></li>
            </nav>
            </div>
          </Slide>
          
        </div>
      </div>
      <hr className='py-2 justify-center' />
      <div className='text-center'>
        <div>
          <h6>© Copyright 2024 , Walkers DAO</h6>
        </div>
        <div className='py-2 text-center flex justify-center'>
          <img alt="logo" src={footer} />
        </div>
      </div>
    </div>
  );
}

export default Footer;
